import { HttpClient, HttpEvent, HttpParams, HttpRequest } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { enpointCervinoWeb } from 'src/app/configuration/enpointsCervino';
import { environment } from './../../../environments/environment';
import { IcaRateModel } from './../../models/management/ica-rate.model';
import { PagedResponseModel } from 'src/app/models/responses/paged-response.model';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';
import { PreInvoicingAlertModel } from 'src/app/models/invoicing/pre-invoicing-alert.models';
import { IcaRateImportModel } from 'src/app/models/imports/ica-rate-import.model';
import { LoadPreInvoicingModel } from 'src/app/models/invoicing/load-preinvoicing.models';

@Injectable({
  providedIn: 'root'
})
export class IcaRateService {

  private readonly _httpClient = inject(HttpClient);

  createIcaRate(icaRateModel: IcaRateModel): Observable<IcaRateModel> {
    return this._httpClient.post<IcaRateModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.icaRate.CreateIcaRate}`,
      icaRateModel);
  }

  deleteIcaRate(icaRateId: number): Observable<IcaRateModel> {
    return this._httpClient.delete<IcaRateModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.icaRate.DeleteIcaRate}/${icaRateId}`);
  }

  downloadGuideImport(): Observable<HttpEvent<Blob>> {
    return this._httpClient.request(new HttpRequest('GET', `${environment.apiCervinoBackend}${enpointCervinoWeb.icaRate.DownloadGuideImport}`,
      null, { reportProgress: true, responseType: 'blob' }));
  }

  exportGeneralConsultation(filters: ColumnResponseModel[], columnSort: string | null, ascendant: boolean): Observable<Blob> {
    const params = new HttpParams().set('columnSort', columnSort ?? '').set('ascendant', ascendant.toString());
    return this._httpClient.post(`${environment.apiCervinoBackend}${enpointCervinoWeb.icaRate.ExportGeneralConsultation}`, filters, {
      params,
      responseType: 'blob',
    });
  }

  exportImportErrors(alerts: PreInvoicingAlertModel[]): Observable<Blob> {
    return this._httpClient.post(`${environment.apiCervinoBackend}${enpointCervinoWeb.icaRate.ExportImportErrors}`, alerts,
      { responseType: 'blob' }
    );
  }

  getAllConceptInvoicingForSelect(): Observable<Array<any>> {
    return this._httpClient.get<Array<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.icaRate.GetAllConceptInvoicingForSelectAsync}`);
  }

  getAllIcaRatesWithPagination(page: number, limit: number, columnSort: string | null, ascendant: boolean, filters: ColumnResponseModel[]): Observable<PagedResponseModel<any>> {
    const params = new HttpParams().set('page', page).set('limit', limit).set('columnSort', columnSort || '').set('ascendant', ascendant);
    return this._httpClient.post<PagedResponseModel<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.icaRate.GetAllIcaRatesWithPaginationAsync}`,
      filters, { params: params }
    );
  }

  getColumnsForGeneralConsultation(): Observable<ColumnResponseModel[]> {
    return this._httpClient.get<ColumnResponseModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.icaRate.GetColumnsForGeneralConsultationAsync}`);
  }

  getIcaRateById(icaRateId: number): Observable<IcaRateModel> {
    return this._httpClient.get<IcaRateModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.icaRate.GetIcaRateById}/${icaRateId}`)
  }

  getIcaRateByCityByConceptInvoicing(cityId: number, conceptInvoicingId: number): Observable<IcaRateModel> {
    return this._httpClient.get<IcaRateModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.icaRate.GetIcaRateByCityByConceptInvoicing}/${cityId}/${conceptInvoicingId}`)
  }

  importIcaRates(icaRatesImports: Array<IcaRateImportModel>): Observable<LoadPreInvoicingModel> {
    return this._httpClient.post<LoadPreInvoicingModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.icaRate.ImportIcaRatesAsync}`,
      icaRatesImports
    );
  }

  updateIcaRate(icaRateModel: IcaRateModel): Observable<IcaRateModel> {
    return this._httpClient.put<IcaRateModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.icaRate.UpdateIcaRate}`,
      icaRateModel
    );
  }
}
